export function bindAll(methods) {
    if (typeof this !== 'undefined') {
        methods
            .forEach(methodName => {
                this[methodName] = this[methodName].bind(this);
            });
    }
}

export function getRegisteredMethods(Class) {
    const classProperties = Object.getOwnPropertyNames(Class.prototype);
    const standardProps = ['constructor', 'render'];
    return classProperties.filter((methodName) => (
        standardProps.indexOf(methodName) < 0 &&
        typeof Class.prototype[methodName] === 'function'
    ));
}



// WEBPACK FOOTER //
// ./src/client/utils/constructorHelper.js